<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width:100%;height:100%"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
    </div>
    <!-- 查询进仓照片 -->
    <picture-view-window :visible.sync="pictureView.visible" :job="job" :model="pictureView.model" :title="pictureView.title" :file-name="pictureView.fileName" :type="pictureView.type" />
  </div>
</template>

<script>

import { warehouseInList } from '@/api/seaExport/warehouseIn'
import { cacheName, cache } from '@/utils/cacheManager'
import pictureViewWindow from '@/components/Cargo/Job/pictureViewWindow'
import ColumnUtils from '@/utils/ColumnUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import StrUtils from '@/utils/StrUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import photo_camera from '@/assets/photo_camera-32.png'
import { DocumentManage } from '@/utils/commonUtil'

export default {
  name: 'TabWarehouseIn',
  components: { pictureViewWindow },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true,
      default: 'look'
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      documentManage: new DocumentManage(),
      gridParams: {},
      selectedRow: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        treeData: true,
        getDataPath: data => {
          return (data.path || '').split(',')
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.getSelectedRow(event)
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.getSelectedRow(event)
        },
        onRowClicked: this.onRowClicked,
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: '',
          width: 220,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: false,
            innerRenderer: (params) => {
              return this.firstColumnLabelFun(params.data.uuid)
            }
          }
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'uuid',
          width: 120,
          cellRenderer: (params) => {
            return this.quantityLabFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          field: 'uuid',
          width: 120,
          cellRenderer: (params) => {
            return this.weightLabFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'uuid',
          width: 120,
          cellRenderer: (params) => {
            return this.cubageLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Size'),
          field: 'dimension',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.WhetherOrNotBroken'),
          field: 'broken',
          width: 120,
          cellRenderer: (params) => {
            return this.isBrokenLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.BrokenDesc'),
          field: 'brokenDes',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.BangPic'),
          field: 'uuid',
          cellRenderer: params => {
            const obj = this.rowData.find(x => x.uuid === params.data.uuid)
            if (obj.parent) {
              const methodPath = this.documentManage.getPath('showAttachHandler')
              return `<span><img src="${photo_camera}" height="16" width="16" style="vertical-align: sub;cursor:pointer" onclick="${methodPath}(event)"/></span>`
            }
            return ''
          },
          width: 120
        },
        // {
        //   headerName: this.$t('SeaExport.WareHouseName'),
        //   field: 'uuid',
        //   width: 120,
        //   cellRenderer: (params) => {
        //     return this.referenceNoLabFun(params.value)
        //   }
        // },
        // {
        //   headerName: this.$t('SeaExport.WareHouseMarks'),
        //   field: 'marks',
        //   width: 120
        // },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          width: 120
        }
      ],
      rowData: [],
      gridApi: null,
      warehouseRecordDialog: {
        visible: false
      },
      pictureView: {
        visible: false,
        title: '',
        model: {},
        fileName: ''
      },
      currentUser: {},
      job: { lob: '' },
      selectedWarehousIn: null,
      btUnlockEnabled: false,
      refreshDocData: false,
      refreshDocActualData: false
    }
  },
  computed: {
    readonly() {
      return this.action === 'look'
    },
    isEdit() {
      return this.action !== 'look'
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showAttachHandler', function() {
      context.showAttachHandler()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  created() {
  },
  methods: {
    // 获取选中行
    getSelectedRow(event) {
      if (!event) return
      if (event.node && event.node.isSelected() && event.data) {
        this.selectedRow = event.data
      }
      if (!this.selectedRow) {
        this.$nextTick(async() => {
          if (this.gridApi && event.column) {
            this.gridApi.forEachNode(node => {
              if (node.rowIndex === event.rowIndex) {
                this.selectedRow = node.data
              }
            })
          }
        })
      }
      if (this.selectedRow && !this.selectedRow.parent) {
        this.selectedRow = null
      }
    },
    async onShow(row, isRefresh) {
      if (isRefresh) {
        await cache.load(cacheName.USER, cacheName.CONFIG)
        this.currentUser = cache.user
        this.job = row
        this.refreshDocData = parseInt(cache.config.get('refreshDocData')) === 1
        this.refreshDocActualData = parseInt(cache.config.get('refreshDocActualData')) === 1
        this.loadWarehouseIn()
      }
    },
    async loadWarehouseIn() {
      /* // 加载数据
      const jobClass = new SeaExportJob(this.job)
      this.rowData = await jobClass.getWarehouseIn()*/
      await warehouseInList(this.job.uuid).then(res => {
        this.rowData = res.data
      })
    },
    firstColumnLabelFun(uuid) {
      var obj = this.rowData.find(x => x.uuid === uuid)
      if (obj.parent) {
        return obj.warehouseNo + ' ' + ColumnUtils.dateLabelFunc(obj.warehouseInDate)
      } else {
        return ColumnUtils.packingCodeLabelFun(obj.packing)
      }
    },
    quantityLabFunc(uuid) {
      var obj = this.rowData.find(x => x.uuid === uuid)
      if (obj.parent) {
        let quantity = 0
        const detailList = this.rowData.filter(val => {
          return val.warehouseInUuid === uuid
        })
        for (const item of detailList) {
          quantity = quantity + item.quantity
        }
        return NumberUtils.formatNumber(quantity)
      } else {
        return obj.quantity
      }
    },
    weightLabFunc(uuid) {
      const obj = this.rowData.find(x => x.uuid === uuid)
      if (obj.parent) {
        let weight = 0
        const detailList = this.rowData.filter(val => {
          return val.warehouseInUuid === uuid
        })
        for (const item of detailList) {
          weight = weight + item.weight
        }
        return NumberUtils.formatNumber(weight, 2)
      } else {
        return obj.weight
      }
    },
    cubageLabelFun(uuid) {
      const obj = this.rowData.find(x => x.uuid === uuid)
      let result = obj.cubage
      if (obj.parent) {
        let cubage = 0
        const detailList = this.rowData.filter(val => {
          return val.warehouseInUuid === uuid
        })
        for (const item of detailList) {
          cubage = cubage + item.cubage
        }
        result = cubage
      }
      return NumberUtils.formatNumber(result, 3)
    },
    isBrokenLabelFunc(broken) {
      if (broken == null) return ''
      return broken ? '√' : ''
    },
    referenceNoLabFun(uuid) {
      const obj = this.rowData.find(x => x.uuid === uuid)
      const referenceNo = obj ? obj.referenceNo : ''
      if (!StrUtils.isEmpty(referenceNo)) {
        if (referenceNo.indexOf('EYGX') > -1) {
          return this.$t('SeaExport.EnyuanGaoxiangku')
        } else if (referenceNo.indexOf('EYYY') > -1) {
          return this.$t('SeaExport.EnyuanYangyuanKu')
        } else if (referenceNo.indexOf('EYHQ') > -1) {
          return this.$t('SeaExport.EnYuanHuaXiaKu')
        } else if (referenceNo.indexOf('EYLD') > -1) {
          return this.$t('SeaExport.EnYuanHuaXiaKu')
        }
      }
    },
    onRowClicked(event) {
      this.selectedRow = event.data
    },
    // 显示进仓图片
    showAttachHandler(e) {
      if (!this.selectedRow) {
        this.$message.warning('请选择一条数据！')
        return
      }
      this.pictureView.title = this.$t('Message.ViewWarehouseEntryPhotos')
      this.pictureView.model = this.selectedRow
      this.pictureView.fileName = this.selectedRow.warehouseNo + '.zip'
      this.pictureView.job = this.job
      this.pictureView.type = 'WarehouseIn'
      this.pictureView.visible = true
    }
  }
}
</script>

<style>
</style>
